import { useLazyQuery } from '@apollo/client';
import {
  EsisJobsInfoInputType,
  JobChangeTypeData,
  JobDetailInput,
  JobDetailsByIdData,
  JobReportByIdData,
  JobReportInputType,
  JobsInfoData,
} from './types';
import {
  ESIS_JOBS_CHANGE_TYPE,
  ESIS_JOBS_DETAIL,
  ESIS_JOBS_INFO,
  ESIS_JOBS_REPORT,
} from '../../apollo/queries/esisLogs/esisLogs.queries';

export const useEsisJobs = () => {
  const [fetchAllJobs, { data, loading }] = useLazyQuery<
    JobsInfoData,
    EsisJobsInfoInputType
  >(ESIS_JOBS_INFO, {
    fetchPolicy: 'cache-and-network',
  });

  return {
    esisJobsData: data?.jobsInfo || { items: [], totalCount: 0 },
    fetchAllJobs,
    isFetchLoaading: loading,
  };
};

export const useEsisJobDetail = () => {
  const [fetchJobDetail, { data, loading }] = useLazyQuery<
    JobDetailsByIdData,
    JobDetailInput
  >(ESIS_JOBS_DETAIL, {
    fetchPolicy: 'cache-and-network',
  });

  return {
    esisJobData: data?.jobDetailsById,
    fetchJobDetail,
    isFetchLoaading: loading,
  };
};

export const useEsisJobReport = () => {
  const [fetchJobReport, { data, loading }] = useLazyQuery<
    JobReportByIdData,
    JobReportInputType
  >(ESIS_JOBS_REPORT, {
    fetchPolicy: 'cache-and-network',
  });

  return {
    esisJobReportData: data?.jobReport,
    fetchJobReport,
    isFetchLoaading: loading,
  };
};

export const useEsisJobChangeType = () => {
  const [fetchJobChangeType, { data, loading }] = useLazyQuery<
    JobChangeTypeData,
    JobDetailInput
  >(ESIS_JOBS_CHANGE_TYPE, {
    fetchPolicy: 'cache-and-network',
  });

  return {
    esisJobChangeTypeData: data?.jobChangeTypes,
    fetchJobChangeType,
    isFetchLoaading: loading,
  };
};
